<app-device-features-container
  [header]="'+INSTALLATIONS.INSTALLATION.SOLAR.TITLE' | translate"
  [overlayType]="availableOverlays.Solar"
  [deviceSelectId]="deviceSelectId"
>
  <!-- solar.sensors.temperature.collector -->
  <app-feature-tile
    *ngIf="solarCollectorTemperature$ | async | ready as feature"
    feature
    data-at-solar-sensors-temperature-collector
    [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.TEMPERATURE_COLLECTOR.TITLE' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- solar.sensors.temperature.dhw -->
  <app-feature-tile
    *ngIf="solarDhwTemperature$ | async | ready as feature"
    feature
    data-at-solar-sensors-temperature-dhw
    [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.TEMPERATURE_DHW.TITLE' | translate"
    value="{{ feature | value2: featurePropertyKey.value }} {{
      feature | unit: featurePropertyKey.value
    }}"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- solar.pumps.circuit -->
  <app-feature-tile
    *ngIf="solarPumps$ | async | ready as feature"
    feature
    data-at-solar-pumps-circuit
    [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.PUMPS.CIRCUIT.TITLE' | translate"
    [value]="feature.properties?.status?.value | translateState | uppercase"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>

  <!-- solar.rechargeSuppression -->
  <app-feature-tile
    *ngIf="solarRechargeSuppression$ | async | ready as feature"
    feature
    data-at-solar-rechargeSuppression
    [label]="'+INSTALLATIONS.INSTALLATION.SOLAR.RECHARGE_SUPPRESSION.TITLE' | translate"
    [value]="feature.properties?.status?.value | translateState | uppercase"
    [attr.data-feature]="feature.feature"
    [error]="feature | error"
  ></app-feature-tile>
</app-device-features-container>
